import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import Storage from "@/app/core/util/Storage";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { useEffect } from "react";
import { Countries } from "@/app/core/util/helpers/MoneyHelper";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";
import AddressField from "@/app/core/layouts/main-components/delivery/AddressField";
import { AddressBookController } from "@/app/core/base/controllers/AddressBookController";
import { toast } from "react-toastify";
import ReactInputMask from "react-input-mask";
import { UserTypeObj } from "@/app/core/util/helpers/UserHelper";

export default function AddressModal({ show, onHide, selected }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({ personType: UserTypeObj.Person });
    const [resultsdata, setResultsdata] = useState([])

    useEffect(() => {
        if (selected != undefined) {
            setData(selected);
        } else {
            setData({});
        }
        console.log("Selecionado", selected);
    }, [selected, show])


    function save() {
        if (data.id == undefined) {
            register(data);
        } else {
            update(data);
        }
        setData({});
    }

    function register(items) {
        if (userData.companyId != null && userData.companyId != undefined) {
            items.companyId = userData.companyId;
        }
        items.userId = userData.id;
        AddressBookController.Insert(items, res => {
            toast.success(Translate(Message.Saved))
            onHide()
        })
    }

    function update(items) {
        if (userData.companyId != null && userData.companyId != undefined) {
            items.companyId = userData.companyId;
        }
        items.userId = userData.id;
        AddressBookController.Update(items, res => {
            toast.success(Translate(Message.Saved))
            onHide()
        })
    }

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type));
        if (evt.target.name == "country_code") {
            setResultsdata(autocomplete(evt.target.value))
        }
    }


    function autocomplete(value) {
        let countries_to_show = [];

        if (value.length > 0) {
            countries_to_show = Autocomplete(value, Countries, "Name");
            return countries_to_show;
        } else {
            countries_to_show = [];
            return [];
        }
    }

    function reportdata(address) {
        setData({ ...data, ...address });
    }

    return (
        <Modal
            title="Remetente ou Destinatário"
            show={show}
            onHide={onHide}
            onSubmit={() => save()}>
            <div className="block-content">
                <div className="" style={{ zIndex: 1051 }}>
                    <AddressField address={data && data.address} teste={data} reportAddress={address => reportdata(address)} />
                </div>
                <div className="form-group">
                    <span>*{Translate(Message.PostalCode)}</span>
                    <input
                        type="text"
                        className="form-control"
                        key={`zipCode-data`}
                        name="zipCode"
                        value={data && data.zipCode}
                        onChange={(evt) => handleChange(evt)}
                    />
                </div>
                <div className="form-group">
                    <span>*{Translate(Message.Number)}</span>
                    <input type="text" className="form-control" name="number" value={data && data.number} onChange={evt => handleChange(evt)}
                        key={`number-data`} />
                </div>
                <div className="form-group">
                    <span>{Translate(Message.Complement)}</span>
                    <input type="text" className="form-control" name="complement" value={data && data.complement} onChange={evt => handleChange(evt)}
                        key={`complement-data`} />
                </div>
                <div className="">
                    <div className="form-group">
                        <span>*{Translate(Message.Country)}</span>
                        <input
                            name="country_code"
                            placeholder="Selecionar"
                            className="form-control"
                            key={`country-data`}
                            defaultInputValue={data && data.country_code}
                            value={data && data.country_code}
                            onChange={(evt) => handleChange(evt)} />

                        <ul
                            style={resultsdata && resultsdata.length > 0 ? {
                                borderRadius: "3px",
                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                background: "rgba(255, 255, 255, 0.9)",
                                padding: "2px 0",
                                fontSize: "90%",
                                position: "fixed",
                                overflow: "auto",
                                marginTop: 10,
                                width: "30%",
                                zIndex: 999999,
                                maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                            } : {
                                borderRadius: "3px",
                            }}>
                            {resultsdata && resultsdata.map((item) => {
                                return (
                                    <li
                                        className="m-3"
                                        onClick={() => setData({ ...data, country_code: item.Code }) | setResultsdata([])}
                                    >
                                        {`(${item.Code}) ${item.Name}`}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="form-group">
                    <span>{Translate(Message.State)}</span>
                    <input type="text" className="form-control" name="state" key="statedata" value={data && data.state} onChange={evt => handleChange(evt)} />
                </div>
                <div className="form-group ">
                    <span>*{Translate(Message.City)}</span>
                    <input type="text" className="form-control" name="city" key="citydata" value={data && data.city} onChange={evt => handleChange(evt)} />
                </div>
                {data && data.country_code == "BR" ?
                    <div className="form-group">
                        <span>{Translate(Message.Neighborhood)}</span>
                        <input type="text" className="form-control" name="neighborhood" placeholder="" value={data && data.neighborhood} onChange={evt => handleChange(evt)} />
                    </div>
                    : ""}
                <div className={"form-group"}>
                    <span>*{Translate(Message.RecipientName)}</span>
                    <input type="text" className="form-control" name="name" key="namedata" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={data && data.name} onChange={evt => handleChange(evt)} />
                </div>
                <div className={"form-group"}>
                    <span>*{Translate(Message.Responsible)}</span>
                    <input type="text" className="form-control" name="responsibleName" key="namedata" placeholder="Ex: Jhon Doe" value={data && data.responsibleName} onChange={evt => handleChange(evt)} />
                </div>
                <div className={"form-group"}>
                    <span>E=mail</span>
                    <input type="text" className="form-control" name="email" key="email" placeholder="Ex: user@email.com" value={data && data.email} onChange={evt => handleChange(evt)} />
                </div>
                <div className={"form-group"}>
                    <span>*{Translate(Message.Phone)}</span>
                    <ReactInputMask
                        mask="99999-9999"
                        maskChar=""
                        type="text"
                        className="form-control"
                        id="advanced-filter-document"
                        name="phone"
                        value={data && data.phone}
                        placeholder="99999-9999"
                        onChange={(event) => {
                            handleChange({
                                target: {
                                    name: "phone",
                                    value: event.target.value.replace(/\D/g, ""),
                                },
                            });
                        }}
                    />
                </div>
                <div class="form-group">
                    <label class="d-block">Tipo</label>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" id="example-rd-custom-inline1"
                            name="personType"
                            checked={data && data.personType == UserTypeObj.Person ? true : false}
                            onChange={evt => setData({ ...data, personType: UserTypeObj.Person })}
                        />
                        <label class="custom-control-label" for="example-rd-custom-inline1">{Translate(Message.PhysicalPerson)}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" class="custom-control-input" id="example-rd-custom-inline2"
                            name="personType"
                            checked={data && data.personType == UserTypeObj.LegalPerson ? true : false}
                            onChange={evt => setData({ ...data, personType: UserTypeObj.LegalPerson })}
                        />
                        <label class="custom-control-label" for="example-rd-custom-inline2">{Translate(Message.LegalPerson)}</label>
                    </div>
                </div>

                {data && data.personType == UserTypeObj.Person ?
                    <div className="form-group">
                        <span>*{Translate(Message.Id)}</span>
                        <ReactInputMask
                            mask="999.999.999-99"
                            maskChar=""
                            type="text"
                            className="form-control"
                            id="advanced-filter-document"
                            name="document"
                            value={data && data.document}
                            placeholder="999.999.999-99"
                            onChange={(event) => {
                                handleChange({
                                    target: {
                                        name: "document",
                                        value: event.target.value.replace("/\D/g", ""),
                                    },
                                });
                            }}
                        />
                    </div>
                    :
                    <div className="form-group">
                        <span>*CNPJ</span>
                        <ReactInputMask
                            mask="99.999.999/9999-99"
                            maskChar=""
                            type="text"
                            className="form-control"
                            id="advanced-filter-document"
                            name="document"
                            value={data && data.document}
                            placeholder="99.999.999/9999-99"
                            onChange={(event) => {
                                handleChange({
                                    target: {
                                        name: "document",
                                        value: event.target.value.replace("/\D/g", ""),
                                    },
                                });
                            }}
                        />
                    </div>
                }
                {data && data.personType == UserTypeObj.Person ?
                    <div className="form-group">
                        <span>*{Translate(Message.Id)}</span>
                        <ReactInputMask
                            mask="99.999.999-9"
                            maskChar=""
                            type="text"
                            className="form-control"
                            id="advanced-filter-document"
                            name="stateTaxId"
                            value={data && data.stateTaxId}
                            placeholder=""
                            onChange={(event) => {
                                handleChange({
                                    target: {
                                        name: "stateTaxId",
                                        value: event.target.value.replace(/\D/g, ""),
                                    },
                                });
                            }}
                        />
                    </div>
                    :
                    <div className="form-group">
                        <span>*Inscrição estadual</span>
                        <input
                            className="form-control"
                            id="advanced-filter-document"
                            name="stateTaxId"
                            value={data && data.stateTaxId}
                            placeholder=""
                            onChange={(event) => handleChange(event)}
                        />
                    </div>
                }
            </div>

        </Modal>
    );
}
